// components/bill-info/component
/* global DEBUG */

import template      from './component.jade'
import Store         from 'Store'
import parseLinks    from 'lib/filters/parseCntLinks'
import onClick       from 'lib/methods/onClick'
import parseUnixTime from 'lib/parseUnixTime.js'

var name = 'bill-info'
var url = '/api/BillInfo'

const store = new Store(name)

export default {

  name: name,
  template: template(),
  props: ['title', 'table'],
  mixins: [parseLinks, onClick],

  data: () => ({
    url: url,
    name: name,
  }),

  computed: {
   modal_title() {
      var data = this.$get('data')
      return data.table[0].number + ' от ' + parseUnixTime(data.table[0].date, 'full', ' ')
    },
    // сумма всех полей summaNDS счета (графа всего)
    summa() {
      var data = this.$get('data')
      return data.table ? data.table.reduce((summaNDS, str) => summaNDS + str.summaNDS, 0) : null
    },
  },

  events: {
    // при запросе счета из строки поиска
    ['number:' + name]: function (data) {
      //DEBUG && console.log('1.number:' + name, 'data', data)
      var {number: number, number: title, date: date} = data
      title = date ? title + ' от ' + parseUnixTime(date, 'full', ' ') : title
      this.$set('number', number)
      this.$set('title', title)
      this.$set('data', null)
      this.$set('data', data)
      this.$set('data', store.$get(this))
    },
  },

}



/** WEBPACK FOOTER **
 ** ./src/js/components/bill-info/component.js
 **/